import React from 'react'

const Work17 = () => {
  return (
    <>
      <h1 className='temp-h1'>Work 2017</h1>
    </>
  )
}

export default Work17